import { render, staticRenderFns } from "./shoukuan.vue?vue&type=template&id=d27ca172"
import script from "./shoukuan.vue?vue&type=script&lang=js"
export * from "./shoukuan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports